import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styles from '../../skincare/skincare_main_concern/SkincareMainConcern.module.sass';
import Button from '../../../../ui_kit/button/Button';
import BackButton from '../../back_button/BackButton';
import HAIR_PRODUCT_TYPES from '../../../constants/hair_product_types';
import HAIR_CATEGORIES from '../../../constants/hair_categories';
import Concern from '../../skincare/skincare_main_concern/concern/Concern';

const MAX_CONCERNS_COUNT = 3;

function HairType(props) {
  const {
    increaseStep, decreaseStep, quiz, step,
  } = props;

  const area = quiz.productType;

  const [concerns, setConcerns] = useState(quiz.concerns);

  const types = HAIR_PRODUCT_TYPES[
    Object.values(HAIR_CATEGORIES).includes(area) ? area : HAIR_CATEGORIES.HAIR_CARE
  ];

  const [customConcern, setCustomConcern] = useState(
    concerns.find((concern) => !types.includes(concern)) || '',
  );

  const onNextClick = () => {
    increaseStep({ ...quiz, concerns });
  };

  const onConcernClicked = (newConcern) => {
    if (concerns.includes(newConcern)) {
      setConcerns(concerns.filter((concern) => concern !== newConcern));
    } else if (concerns.length < MAX_CONCERNS_COUNT) {
      setConcerns([...concerns, newConcern]);
    }
  };

  const isCustomConcernEditable = () => concerns.includes(
    customConcern,
  ) || concerns.length < MAX_CONCERNS_COUNT;

  const onCustomConcernChange = (updatedConcern) => {
    const newConcerns = concerns.filter((concern) => concern !== customConcern);
    setConcerns(newConcerns);
    if (newConcerns.length === MAX_CONCERNS_COUNT) { return; }

    setCustomConcern(updatedConcern);
    if (updatedConcern.length > 0) {
      setConcerns([...newConcerns, updatedConcern]);
    }
  };

  const { color } = quiz;

  const title = () => {
    switch (area) {
      case HAIR_CATEGORIES.HAIR_CARE:
        return 'What’s your biggest concern with your hair type?';
      case HAIR_CATEGORIES.HAIR_STYLING:
        return 'Which style for your hair needs more flare?';
      case HAIR_CATEGORIES.HAIR_COLOR:
        return 'Which color concern addresses your tresses?';
      default:
        return 'What’s your biggest concern with your hair type?';
    }
  };

  return (
    <>
      <BackButton decreaseStep={() => { decreaseStep({ ...quiz, concerns }); }} />
      <div className={styles['main-concern']}>
        <div className={styles.content}>
          {step}
          <h1 className={styles.title}>
            {title()}
          </h1>
          <div className={styles.description}>
            Choose up to 3.
          </div>
          <div className={styles.concerns}>
            {types.map((concern) => (
              <Concern
                onClick={() => { onConcernClicked(concern); }}
                key={concern}
                concern={concern}
                isActive={concerns.includes(concern)}
                color={color}
              />
            ))}
            <Concern
              onChange={onCustomConcernChange}
              concern={isCustomConcernEditable() ? customConcern : 'Other, Type Here'}
              className={!isCustomConcernEditable() ? styles.disabled : null}
              editable={isCustomConcernEditable()}
              isActive={concerns.includes(customConcern)}
              color={color}
            />
          </div>
          <Button
            className={`${styles.button} custom-transparent-button`}
            onClickHandler={onNextClick}
            disabled={concerns.length === 0}
            text="NEXT"
            color="transparent-blue"
            size="small"
          />
        </div>
      </div>
    </>
  );
}

HairType.propTypes = {
  increaseStep: PropTypes.func.isRequired,
  decreaseStep: PropTypes.func.isRequired,
  quiz: PropTypes.shape({
    productType: PropTypes.string,
    concerns: PropTypes.arrayOf(PropTypes.string),
    color: PropTypes.string,
  }).isRequired,
  step: PropTypes.node.isRequired,
};

export default HairType;
